import styled, { createGlobalStyle } from 'styled-components';

export const Page = styled.div`
  background: #f5f5f5;
  padding: 20px;
  min-height: 100%;
  box-sizing: border-box;
  direction: ${props => (props.lang === 'ar' ? 'rtl' : 'ltr')};
  font-family: ${props => (props.lang === 'ar' ? 'TheSansArabic' : 'SourceSansPro')}, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
`;

export const Baseline = createGlobalStyle`
  :where(.vpay-page),
  :where(.vpay-page) * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  :where(.vpay-page) * {
    font-family: inherit;
  }
  .vpay-page * {
    user-select: text;
  }
  :where(.vpay-page) *::before,
  :where(.vpay-page) *::after {
    box-sizing: border-box;
  }
  :where(.vpay-page) button,
  :where(.vpay-page) input,
  :where(.vpay-page) textarea {
    font-family: inherit;
  }
  :where(.vpay-page) button {
    cursor: pointer;
  }
  :where(.vpay-page) button:disabled {
    cursor: default;
  }
`;
